export { default as Favorite } from './Favorite';



// WEBPACK FOOTER //
// ./src/components/Favorite/index.ts